import clsx from "clsx";

export const InputNumber = ({
                              min=0, max=999,
                              value, setValue, disabled=false,
                              placeholder=null, theme="light", size="md", helper=null, className
}) => {

  const handleOnChange = (e) => {
    let value = e.target.value;
    value = (!value || isNaN(value)) ? 0 : parseInt(e.target.value);

    setValue?.(value);
  };

  const getThemeClasses = () => {
    return theme === 'light' ?
      'text-perception-gray-700 bg-gray-100' :
      'text-perception-gray-500 bg-perception-black-500 placeholder-perception-gray-700';
  };

  const getSizeClasses = () => {
    return size === 'sm' ? 'text-sm px-2 py-1 border-1' :
      size === 'lg' ? 'text-xl px-4 py-2 border-2' :
        'px-2 py-1 border-1'; // default & md
  };

  const getHelperSizeClasses = () => {
    return size === 'sm' ? 'text-xs' :
      size === 'md' ? 'text-xs' :
        size === 'lg' ? 'text-sm' : '';
  };

  return (
    <div className="inline-block flex flex-col items-end">
      <input
        type="number"
        value={value}
        onChange={handleOnChange}
        min={min}
        max={max}
        className={clsx(getThemeClasses(), getSizeClasses(), 'rounded-md outline-none border-transparent focus:border-perception-blue',
          'appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none', className)}
        disabled={disabled}
        placeholder={placeholder}
      />
      {
        helper && <p className={clsx(getHelperSizeClasses(), 'text-perception-gray-600 mt-1')}>{helper}</p>
      }
    </div>
  );
};